import React, { useState } from "react";
import { Box, Grid, Fade, Tooltip } from "@mui/material";
import { OptionsIcon } from "../../Icons/optionsIcon";
import { ApplicantCrossIcon } from "../../Icons/ApplicantCrossIcon";

const InlineActions = ({ actions, hideClose = false }) => {
  const [open, setOpen] = useState(false);

  const ActionItem = ({ icon, label, onClick }) => (
    <Box display="flex" flexDirection="column" alignItems="center" gap={0.5}>
      <Tooltip title={label} arrow>
        <span
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
          style={{ cursor: "pointer", display: "flex" }}
          aria-label={label}
        >
          {icon}
        </span>
      </Tooltip>
    </Box>
  );

  if (!open) {
    return (
      <Tooltip title="View More Options" arrow>
        <span
          style={{ cursor: "pointer", display: "flex" }}
          onClick={(e) => {
            e.stopPropagation();
            setOpen(true);
          }}
        >
          <OptionsIcon />
        </span>
      </Tooltip>
    );
  }

  return (
    <Fade in={open}>
      <Grid
        container
        spacing={2}
        alignItems="center"
        wrap="nowrap"
        sx={{ mx: 0, width: "auto" }}
      >
        {actions.map((a, idx) => (
          <Grid item key={idx}>
            <ActionItem icon={a.icon} label={a.label} onClick={a.onClick} />
          </Grid>
        ))}
        {!hideClose && (
          <Grid item>
            <ActionItem
              icon={<ApplicantCrossIcon />}
              label="Close"
              onClick={() => setOpen(false)}
            />
          </Grid>
        )}
      </Grid>
    </Fade>
  );
};

export default InlineActions;
